import { OrderAllocationStatus } from "~/gql/graphqlBase.generated";
import i18n from "~/i18n/i18n";

const ALLOCATION_STATUS_LABEL_KEYS: Record<OrderAllocationStatus, string> = {
	[OrderAllocationStatus.Allocated]: "orders.allocation.status.allocated",
	[OrderAllocationStatus.MakeToOrder]: "orders.allocation.status.makeToOrder",
	[OrderAllocationStatus.NotStarted]: "orders.allocation.status.notStarted",
	[OrderAllocationStatus.Partial]: "orders.allocation.status.partial",
	[OrderAllocationStatus.Short]: "orders.allocation.status.short"
};

const formatAllocationStatusLabel = (value: unknown): string => {
	const key = ALLOCATION_STATUS_LABEL_KEYS[value as OrderAllocationStatus];
	return key ? i18n.t(key, { ns: "fulfill" }) : "";
};

export default formatAllocationStatusLabel;
